import { render, staticRenderFns } from "./CoSAllocationForm.vue?vue&type=template&id=1ea3825a&lang=pug"
import script from "./CoSAllocationForm.vue?vue&type=script&lang=ts"
export * from "./CoSAllocationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports